import { render, staticRenderFns } from "./NameNumberTable.vue?vue&type=template&id=22329518&scoped=true"
import script from "./NameNumberTable.vue?vue&type=script&lang=js"
export * from "./NameNumberTable.vue?vue&type=script&lang=js"
import style0 from "./NameNumberTable.vue?vue&type=style&index=0&id=22329518&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22329518",
  null
  
)

export default component.exports